import { graphql } from '@gql/types';

export const EXTERNAL_USER_QUERY = graphql(`
  query ExternalUser($providerId: String!) {
    externalUser(providerId: $providerId) {
      id
      name
      email
      providerId
      authProvider
      phoneNumber
      isActive
    }
  }
`);
